// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2022 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { WidgetDefinition } from "@insite/client-framework/Types/ContentItemDefinitions";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import PardotForm from "@mcmc/App/Components/PardotForm/PardotForm";
import React from "react";

export const enum fields {
    formUrl = "formUrl",
    specifyHeight = "specifyHeight",
    height = "height",
}

interface PardotWidgetProps extends WidgetProps {
    fields: {
        [fields.formUrl]: string;
        [fields.specifyHeight]: boolean;
        [fields.height]: number;
    };
}

type Props = PardotWidgetProps;

const PardotWidget: React.FC<Props> = ({ fields: { formUrl, specifyHeight, height } }) => {
    return <PardotForm formUrl={formUrl} {...specifyHeight && { height }} />;
};

export const definition: WidgetDefinition = {
    group: "Basic",
    fieldDefinitions: [
        {
            name: fields.formUrl,
            displayName: "Form Url",
            editorTemplate: "TextField",
            defaultValue: "",
            isRequired: true,
            fieldType: "Contextual",
        },
        {
            name: fields.specifyHeight,
            displayName: "Specify Iframe Height",
            editorTemplate: "CheckboxField",
            defaultValue: false,
            fieldType: "General",
        },
        {
            name: fields.height,
            displayName: "Iframe Height (px)",
            editorTemplate: "IntegerField",
            min: 1,
            defaultValue: 1,
            fieldType: "General",
            isVisible: item => item.fields.specifyHeight,
        },
    ],
};

const widgetModule: WidgetModule = {
    component: PardotWidget,
    definition,
};

export default widgetModule;
